import {
  FilterCheckbox,
  FilterDateRange,
  FilterType,
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"

export const headers: SoDataTableHeader[] = [
  {
    title: "Account Number",
    key: "accountNumber",
    sortKey: "account_number",
  },
  {
    title: "Full Name",
    key: "fullName",
    sortKey: "last_name",
  },
  {
    title: "Email",
    key: "email",
    sortable: false,
  },
  {
    title: "Address Line 1",
    key: "addressLine1",
    sortable: false,
  },
  {
    title: "Post Code",
    key: "postCode",
    sortable: false,
  },
  {
    title: "Date Of Birth",
    key: "dateOfBirth",
    sortKey: "date_of_birth",
  },
  {
    title: "Deposit Amount",
    key: "amount",
    sortable: false,
    type: SoDataTableColumnType.MONEY,
  },
  {
    title: "Deposit Deadline",
    key: "depositDeadline",
    sortKey: "deposit_deadline_dt",
    type: SoDataTableColumnType.DATE,
  },
  {
    title: "Status",
    key: "status",
    sortKey: "status",
  },
  {
    title: "Account Active",
    key: "isAccountActive",
    sortable: false,
    type: SoDataTableColumnType.YES_OR_NO,
  },
]

export type CreditCheckStatuses =
  | "SWITCH_NOT_ACTIVE"
  | "DEPOSIT_REQUEST_FAILED"
  | "DEPOSIT_REQUESTED"
  | "DEPOSIT_PAID"
  | "DEPOSIT_RECEIVED_EMAIL_FAILED"
  | "DEPOSIT_RECEIVED_EMAIL_SENT"
  | "FAILED_TO_CANCEL_SWITCH_BY_SOE"
  | "SWITCH_CANCELLED_BY_SOE"
  | "CANCELLATION_EMAIL_FAILED"
  | "CANCELLATION_EMAIL_SENT"
  | "SCORED_CA"
  | "FAILED_TO_SCORE_CA"
  | "NO_SCORE_CA"

export const statuses = {
  SWITCH_NOT_ACTIVE: "Switch Not Active",
  DEPOSIT_REQUEST_FAILED: "Deposit Request Failed",
  DEPOSIT_REQUESTED: "Deposit Requested",
  DEPOSIT_PAID: "Deposit Paid",
  DEPOSIT_RECEIVED_EMAIL_FAILED: "Deposit Received Email - Failed",
  DEPOSIT_RECEIVED_EMAIL_SENT: "Deposit Received Email - Sent",
  FAILED_TO_CANCEL_SWITCH_BY_SOE: "Failed to Cancel by SOE",
  SWITCH_CANCELLED_BY_SOE: "Switch Cancelled by SOE",
  CANCELLATION_EMAIL_FAILED: "Cancellation Email - Failed",
  CANCELLATION_EMAIL_SENT: "Cancellation Email - Sent",
  SCORED_CA: "Successful TU hard score",
  FAILED_TO_SCORE_CA: "Failed TU hard score",
  NO_SCORE_CA: "Successful TU hard score - No match found",
}

export type CreditCheckFilters = {
  depositDeadline?: { from: Date | null; to: Date | null }
  status?: string[]
}

export type TableFilters = {
  depositDeadline: FilterDateRange
  status: FilterCheckbox<CreditCheckStatuses>
}

export const tableFilters: TableFilters = {
  depositDeadline: {
    type: FilterType.DATE_RANGE,
    label: "Deposit Deadline",
    value: { from: null, to: null },
    expandable: true,
  },
  status: {
    type: FilterType.CHECKBOX,
    label: "Deposit Status",
    value: ["DEPOSIT_REQUESTED"],
    expandable: true,
    options: statuses,
  },
}
